import { functions } from "../firebase";

// Client wrappers for the first-party X (Twitter) callables (functions/src/
// xPublishing.ts). Mirrors linkedinConnection.ts: tokens NEVER cross this
// boundary — the connection read returns only display chrome, and publishing is
// done entirely server-side.

export type XConnection = {
  connected: boolean;
  username?: string;
  name?: string;
  scopes?: string[];
};

export type XPublishResult = {
  ok: boolean;
  postId?: string;
};

// Read the community's X connection state for the connect panel.
export const getXConnection = async (communityId: string): Promise<XConnection> => {
  const callable = functions.httpsCallable("xGetConnection");
  const res = await callable({ communityId });
  return res.data as XConnection;
};

// Start OAuth: returns the authorize URL to open in a popup.
export const startXAuth = async (communityId: string): Promise<{ url: string }> => {
  const callable = functions.httpsCallable("xStartAuth");
  const res = await callable({ communityId });
  return res.data as { url: string };
};

// Finish OAuth: the /auth/x/callback route calls this with the ?code and ?state
// X returned.
export const completeXAuth = async (params: {
  code: string;
  state: string;
}): Promise<XConnection> => {
  const callable = functions.httpsCallable("xCompleteAuth");
  const res = await callable(params);
  return res.data as XConnection;
};

// Publish a post to the coach's X timeline. Give a MediaProject id (to pull its
// caption / first slide) OR explicit text. Text is capped at 280 chars server-side.
export const publishXPost = async (params: {
  communityId: string;
  text?: string;
  projectId?: string;
  imageUrl?: string;
}): Promise<XPublishResult> => {
  const callable = functions.httpsCallable("xCreatePost", { timeout: 120000 });
  const res = await callable(params);
  return res.data as XPublishResult;
};

// Clear the community's X connection.
export const disconnectX = async (
  communityId: string
): Promise<{ connected: boolean }> => {
  const callable = functions.httpsCallable("xDisconnect");
  const res = await callable({ communityId });
  return res.data as { connected: boolean };
};
